import { render, staticRenderFns } from "./ActtivResult.vue?vue&type=template&id=2c2d81f6&scoped=true&"
import script from "./ActtivResult.vue?vue&type=script&lang=js&"
export * from "./ActtivResult.vue?vue&type=script&lang=js&"
import style0 from "./ActtivResult.vue?vue&type=style&index=0&id=2c2d81f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2d81f6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex,VLayout})
